import { render } from "./CustomProgressNote.vue?vue&type=template&id=55d6fa16&scoped=true&ts=true"
import script from "./CustomProgressNote.vue?vue&type=script&lang=ts"
export * from "./CustomProgressNote.vue?vue&type=script&lang=ts"

import "./CustomProgressNote.vue?vue&type=style&index=0&id=55d6fa16&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d6fa16"]])

export default __exports__